import type { Jet } from '~/jet';
import type { LoggerFactory } from '@amp/web-apps-logger';
import type { FullScreenPlayerStateStore } from '~/stores/full-screen-player';
import type { CloseFullScreenPlayerAction } from '@jet-app/music-classical/action-model/CloseFullScreenPlayerAction';

export type Dependencies = {
    jet: Jet;
    logger: LoggerFactory;
    fullScreenPlayerState: FullScreenPlayerStateStore;
};

export function registerHandler(dependencies: Dependencies) {
    const { jet, logger, fullScreenPlayerState } = dependencies;

    const log = logger.loggerFor(
        'jet/action-handlers/close-full-screen-player-action',
    );

    jet.onAction(
        'closeFullScreenPlayerAction',
        async (action: CloseFullScreenPlayerAction) => {
            log.info('received CloseFullScreenPlayer:', action);

            fullScreenPlayerState.setVisibility(false);

            return 'performed';
        },
    );
}
